import 'reflect-metadata';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createHead } from '@unhead/vue';

import '@/css/tailwind.css';
import '@/css/colors.css';
import '@/css/controls.css';
import '@/css/fonts.css';
import '@/css/smart-banner.css';
import '@/css/default.theme.css';
import '@/css/theme.ewa.css';
import '@/css/mobile.ewa.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'smartbanner.js/dist/smartbanner.min.css';
import 'smartbanner.js/dist/smartbanner';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { initGtm } from './common';
import { initSentry } from './composables';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const head = createHead();

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(head);
initGtm(app, router);
initSentry(app);

app.mount('#app');
